// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_7a3fb80146--tooltip--Jsh1z","arrow_tooltip":"_7a3fb80146--arrow_tooltip--SRU9V","arrow":"_7a3fb80146--arrow--A4pue"};